module.exports = "/_next/static/images/WarehouseData@2x-c738effa51b895675d1a35257f23c940.webp";